import { API_BASE } from "../utils/api";
import { isBMI } from "./config";

export const fetchProductByCode = async ({
    code,
    user,
    myaccountId,
}) => {
    if (!code || !user?.idCustomer || !myaccountId) return null;

    const res = await fetch(`${API_BASE}/inventary-ultra/api/ws/search_products_api?myaccount_id=${myaccountId}&bodega_id=${user.bodegaId}&id_customer=${user.idCustomer}&search=${encodeURIComponent(code)}&solo_acuerdo=${isBMI(user)}`
    );

    const data = await res.json();

    // coincidencia exacta por código
    return data?.find((p) => p.productId === code) || null;
};
